import { TAG_USER_ROLE_ID } from 'ifield-core-components'
import { APP_USER_ROLE_IDS, USER_TYPE } from '@/constants.js'

/**
 * クラスタ内のユーザー種別ごとの件数を数える
 * @param {Array} children クラスタの子要素 (ユーザー情報)
 * @returns {Object} 種別ごとの件数 (appUsers, tagUsers)
 */
export const countUsersByType = (children) => {
  let appUsers = 0
  let tagUsers = 0
  for (const user of children || []) {
    if (user.role_id === TAG_USER_ROLE_ID) {
      tagUsers++
    } else if (APP_USER_ROLE_IDS.includes(user.role_id)) {
      appUsers++
    }
  }
  return { appUsers, tagUsers }
}

/**
 * クラスタ内のユーザー種別を判定する
 * @param {Array} children クラスタの子要素 (ユーザー情報)
 * @returns {String|null} ユーザー種別 (app, tag, mixed)、判定不能な場合は null
 */
export const getUserTypeFromCluster = (children) => {
  if (!children || !children.length) {
    return null
  }
  const { appUsers, tagUsers } = countUsersByType(children)

  if (appUsers && tagUsers) {
    return USER_TYPE.MIXED
  } else if (appUsers) {
    return USER_TYPE.APP
  } else if (tagUsers) {
    return USER_TYPE.TAG
  }
  return null
}
